module.exports = __webpack_public_path__ + "img/laptop-2411303_1280.469ae40c.jpg";